// axios
import axios from 'axios'
import { isNetworkError, markRequestFailure, markRequestSuccess } from '@/helpers/networkStatus'
import { withTenantKey } from '@/libs/storageKeys'

function readJsonFile(file) {
  const rawFile = new XMLHttpRequest()
  let fileContext = null
  rawFile.open('GET', file, false) // using synchronous call
  rawFile.onreadystatechange = () => {
    if (rawFile.readyState === 4) {
      const hasContent = typeof rawFile.responseText === 'string' && rawFile.responseText.trim() !== ''
      if ((rawFile.status === 200 || rawFile.status === 0) && hasContent) {
        try {
          fileContext = JSON.parse(rawFile.responseText)
        } catch (error) {
          fileContext = null
        }
      }
    }
  }
  try {
    rawFile.send(null)
  } catch (error) {
    return null
  }
  return fileContext
}
const appConfig = readJsonFile('/app.config.json') || {}

const baseURL = appConfig.apiUrl || ''

const storedTokens = localStorage.getItem(withTenantKey('tokens'))
if (storedTokens) {
  try {
    const parsedTokens = JSON.parse(storedTokens)
    if (parsedTokens?.token) {
      axios.defaults.headers.common.Authorization = `Bearer ${parsedTokens.token}`
    }
  } catch (error) {
    // Ignore malformed storage in tests and broken local sessions.
  }
}

const axiosIns = axios.create({
  baseURL,
  withCredentials: true,
})

axiosIns.interceptors.request.use(config => ({
  ...config,
  metadata: {
    ...(config.metadata || {}),
    startedAt: Date.now(),
  },
}))

axiosIns.interceptors.response.use(
  response => {
    const startedAt = response.config?.metadata?.startedAt
    markRequestSuccess(startedAt ? Date.now() - startedAt : null)

    return response
  },
  error => {
    if (isNetworkError(error)) {
      const networkError = Object.assign(error, { isNetworkError: true })
      markRequestFailure()

      return Promise.reject(networkError)
    }

    return Promise.reject(error)
  },
)

export default axiosIns
